import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import CreateAccount from './pages/CreateAccount';
import GuestApply from './pages/GuestApply';
import PasswordReset from './pages/PasswordReset';
import TempRegister from './pages/TempRegister';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminSchedule from './pages/admin/AdminSchedule';
import AdminGuests from './pages/admin/AdminGuests';
import AdminMembers from './pages/admin/AdminMembers';
import AdminMemberApplications from './pages/admin/AdminMemberApplications';
import AdminFees from './pages/admin/AdminFees';
import AdminUniforms from './pages/admin/AdminUniforms';
import AdminNotices from './pages/admin/AdminNotices';
import AdminCompetitions from './pages/admin/AdminCompetitions';
import AdminMenuSettings from './pages/admin/AdminMenuSettings';
import AdminEvents from './pages/admin/AdminEvents';
import AdminDormant from './pages/admin/AdminDormant';
import MemberDashboard from './pages/member/MemberDashboard';
import MemberSchedule from './pages/member/MemberSchedule';
import MemberFees from './pages/member/MemberFees';
import MemberUniform from './pages/member/MemberUniform';
import MemberGuestApply from './pages/member/MemberGuestApply';
import MemberNotices from './pages/member/MemberNotices';
import MemberCompetitions from './pages/member/MemberCompetitions';
import MemberMyPage from './pages/member/MemberMyPage';
import MemberEvents from './pages/member/MemberEvents';
import MomCalendar from './pages/MomCalendar';
import './styles/global.css';

const App: React.FC = () => {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          {/* 공개 페이지 */}
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/create-account" element={<CreateAccount />} />
          <Route path="/guest-apply" element={<GuestApply />} />
          <Route path="/password-reset" element={<PasswordReset />} />
          <Route path="/temp-register" element={<TempRegister />} />
          <Route path="/mom/calendar" element={<MomCalendar />} />
          
          {/* 관리자 페이지 */}
          <Route 
            path="/admin" 
            element={
              <ProtectedRoute requireAdmin={true}>
                <AdminDashboard />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/admin/members" 
            element={
              <ProtectedRoute requireAdmin={true}>
                <AdminMembers />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/admin/member-applications" 
            element={
              <ProtectedRoute requireAdmin={true}>
                <AdminMemberApplications />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/admin/schedule" 
            element={
              <ProtectedRoute requireAdmin={true}>
                <AdminSchedule />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/admin/fees" 
            element={
              <ProtectedRoute requireAdmin={true}>
                <AdminFees />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/admin/uniforms" 
            element={
              <ProtectedRoute requireAdmin={true}>
                <AdminUniforms />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/admin/guests" 
            element={
              <ProtectedRoute requireAdmin={true}>
                <AdminGuests />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/admin/notices" 
            element={
              <ProtectedRoute requireAdmin={true}>
                <AdminNotices />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/admin/competitions" 
            element={
              <ProtectedRoute requireAdmin={true}>
                <AdminCompetitions />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/admin/menu-settings" 
            element={
              <ProtectedRoute requireAdmin={true}>
                <AdminMenuSettings />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/admin/events" 
            element={
              <ProtectedRoute requireAdmin={true}>
                <AdminEvents />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/admin/dormant" 
            element={
              <ProtectedRoute requireAdmin={true}>
                <AdminDormant />
              </ProtectedRoute>
            } 
          />
          
          {/* 일반 회원 페이지 */}
          <Route 
            path="/member" 
            element={
              <ProtectedRoute>
                <MemberDashboard />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/member/schedule" 
            element={
              <ProtectedRoute>
                <MemberSchedule />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/member/fees" 
            element={
              <ProtectedRoute>
                <MemberFees />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/member/uniforms" 
            element={
              <ProtectedRoute>
                <MemberUniform />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/member/guest-apply" 
            element={
              <ProtectedRoute>
                <MemberGuestApply />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/member/notices" 
            element={
              <ProtectedRoute>
                <MemberNotices />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/member/competitions" 
            element={
              <ProtectedRoute>
                <MemberCompetitions />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/member/mypage" 
            element={
              <ProtectedRoute>
                <MemberMyPage />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/member/events" 
            element={
              <ProtectedRoute>
                <MemberEvents />
              </ProtectedRoute>
            } 
          />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
};

export default App;

